import { render, staticRenderFns } from "./DoKoBockInfo.vue?vue&type=template&id=bdac5d88&"
import script from "./DoKoBockInfo.vue?vue&type=script&lang=ts&"
export * from "./DoKoBockInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports